module.exports = __webpack_public_path__ + "img/icons B_35.4d8cd287.svg";